import { GiveawayLinkStatus } from 'swag-common/constants/giveaway.constants';
export const isGiveawayLinkCompleted = status => {
  return ![GiveawayLinkStatus.NEW, GiveawayLinkStatus.OPENED].includes(status);
};